import { useCallback, useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { useBoardTheme } from '@exports/hooks/useBoardTheme';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { useFastGameCtx } from '@features/game/providers/FastGameProvider';
import { IPoolType } from '@features/game/types/fast-game';
import { OnlineGamesModalWidget } from '@features/game/ui/OnlineGamesModal/OnlineGamesModalWidget';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';

import { PairingLobbyPage } from './PairingLobbyPage';

export function PairingLobbyPageWidget({ initialPool }: { initialPool: IPoolType | undefined }) {
  const { boardTheme } = useBoardTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery() !== 'desktop';

  const onClose = useCallback(() => {
    navigate({ to: '/' });
  }, [navigate]);

  const fg = useFastGameCtx();
  useEffect(() => {
    if (initialPool) {
      const s = fg.select;
      s([initialPool]);
    } else {
      const r = fg.reset;
      r();
    }
  }, [initialPool, fg.select, fg.reset]);

  return (
    <PairingLobbyPage
      avatar={
        <>
          <UserSettingsMenuWidget />
          <UserAuthMenuWidget alwaysRound />
        </>
      }
      modal={
        <OnlineGamesModalWidget
          position="centered"
          onClose={isMobile ? onClose : undefined}
          closeText="Вернуться на главную"
        />
      }
      boardTheme={boardTheme}
    />
  );
}
